import {Box, CircularProgress, Typography} from '@mui/material';
import {Container} from '@mui/system';
import React, {useContext, useEffect, useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';

import {Context} from "../..";
import ServiceItem from './ServiceItem';
import {fetchServices, reorderServices} from '../../http/clinicServiceAPI';

const ServiceList = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    const {user} = useContext(Context);

    useEffect(() => {
        setLoading(true); // Set loading to true before fetching
        fetchServices(user.user.clinicId)
            .then((data) => {
                setServices(data.sort((a, b) => a.index - b.index));
            })
            .catch((error) => {
                console.error('Error fetching services:', error); // Basic error logging
            })
            .finally(() => {
                setLoading(false); // Set loading to false after fetch completes
            });
    }, [user.user.clinicId]);

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const newServices = Array.from(services);
        const [moved] = newServices.splice(result.source.index, 1);
        newServices.splice(result.destination.index, 0, moved);

        setServices(newServices); // Local update
        const orderData = newServices.map((service, index) => ({
            id: service.id,
            order: index,
        }));

        reorderServices(orderData).catch((error) => {
            console.error('Ошибка обновления порядка:', error);
            // Optionally revert: setServices([...services]);
        });
    };

    return (
        <Container disableGutters sx={{ px: 0 }}>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '200px', // Ensure loading spinner is centered vertically
                    }}
                >
                    <CircularProgress aria-label="Загрузка услуг"/>
                </Box>
            ) : (
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="services-list">
                        {(provided) => (
                            <Container
                                disableGutters
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    flexDirection: 'column',
                                    gap: 2,
                                    p: 0,
                                }}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {services.length > 0 ? (
                                    services.map((service, index) => (
                                        <Draggable key={service.id} draggableId={service.id} index={index}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={{...provided.draggableProps.style}}
                                                >
                                                    <ServiceItem service={service}/>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))
                                ) : (
                                    <Box sx={{textAlign: 'center', py: 2}}>
                                        <Typography variant="body1" color="textSecondary">
                                            Нет услуг для отображения
                                        </Typography>
                                    </Box>
                                )}
                                {provided.placeholder}
                            </Container>
                        )}
                    </Droppable>
                </DragDropContext>
            )}
        </Container>
    );
};
export default ServiceList;
